import { render, staticRenderFns } from "./UserAccountEdit.vue?vue&type=template&id=21104ae4&scoped=true&"
import script from "./UserAccountEdit.vue?vue&type=script&lang=js&"
export * from "./UserAccountEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountEdit.vue?vue&type=style&index=0&id=21104ae4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21104ae4",
  null
  
)

export default component.exports